import type { TError, TFeedSpaceItem } from '@onesource/schemas';
import { queryOptions, useQuery } from '@tanstack/react-query';

import axios from '../../axios';
import { ENTITY } from '../entity';

/**
 * Query key for fetching feed spaces - non-hook version
 */
export const getFeedSpacesQueryKey = () => [ENTITY, 'feed-spaces'];

/**
 * Query key for fetching feed spaces
 */
export const useGetFeedSpacesQueryKey = () => getFeedSpacesQueryKey();

/**
 * Query options for feed spaces — shared by the hook and by route guards that
 * need the data in `beforeLoad` (via `queryClient.ensureQueryData`).
 */
export const getFeedSpacesQueryOptions = () =>
  queryOptions<TFeedSpaceItem[], TError>({
    queryKey: getFeedSpacesQueryKey(),
    queryFn: async () => {
      const res = await axios.get<TFeedSpaceItem[]>('/community-hub/feed-spaces');
      return res.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

/**
 * Hook to fetch all feed-type spaces with access info
 * Used for sidebar Community menu to show feed spaces with locked state
 *
 * @returns List of feed spaces with hasAccess flag
 */
export const useGetFeedSpaces = () => {
  return useQuery(getFeedSpacesQueryOptions());
};
